export const Copy = () => (
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 11C12.5312 11 13 10.5625 13 10V3.625C13 3.5 12.9375 3.375 12.8438 3.28125L10.7188 1.15625C10.625 1.0625 10.5 1 10.375 1H7C6.4375 1 6 1.46875 6 2V10C6 10.5625 6.4375 11 7 11H12ZM13.5312 2.5625C13.8125 2.84375 14 3.25 14 3.625V10C14 11.125 13.0938 12 12 12H7C5.875 12 5 11.125 5 10V2C5 0.90625 5.875 0 7 0H10.375C10.75 0 11.1562 0.1875 11.4375 0.46875L13.5312 2.5625ZM2 4H4V5H2C1.4375 5 1 5.46875 1 6V14C1 14.5625 1.4375 15 2 15H7C7.53125 15 8 14.5625 8 14V13H9V14C9 15.125 8.09375 16 7 16H2C0.875 16 0 15.125 0 14V6C0 4.90625 0.875 4 2 4Z"
      fill="currentColor"
    />
  </svg>
);
